export default __webpack_public_path__ + "75ab7cb2f7f1e422e7ebd4a0962efad4.jpg";